const contextos = {
  "CRM": {
    "DEV": {
      reiniciar: process.env.REACT_APP_CRM_REINICIAR_DEV,
      atualizar: process.env.REACT_APP_CRM_ATUALIZAR_DEV
    },
    "PROD": {
      reiniciar: process.env.REACT_APP_CRM_REINICIAR_PROD,
      atualizar: process.env.REACT_APP_CRM_ATUALIZAR_PROD
    },
    "AMBIENTE_TESTE": {
      reiniciar: process.env.REACT_APP_CRM_REINICIAR_AMBIENTE_TESTE,
      atualizar: process.env.REACT_APP_CRM_ATUALIZAR_AMBIENTE_TESTE
    },
  },
  "Locação": {
    "DEV": {
      reiniciar: process.env.REACT_APP_LOCACAO_REINICIAR_DEV,
      atualizar: process.env.REACT_APP_LOCACAO_ATUALIZAR_DEV
    },
    "PROD": {
      reiniciar: process.env.REACT_APP_LOCACAO_REINICIAR_PROD,
      atualizar: process.env.REACT_APP_LOCACAO_ATUALIZAR_PROD
    },
    "AMBIENTE_TESTE": {
      reiniciar: process.env.REACT_APP_LOCACAO_REINICIAR_AMBIENTE_TESTE,
      atualizar: process.env.REACT_APP_LOCACAO_ATUALIZAR_AMBIENTE_TESTE
    },
  }
};

export default contextos;